const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class MobileCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    window.setTimeout(() => {
      this.carousel = this.setupCarousel()
    }, 1000)
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.35,
          spacing: 0,
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('mobile-carousel')) {
  customElements.define('mobile-carousel', MobileCarousel)
}
